import { render, staticRenderFns } from "./YesButton.vue?vue&type=template&id=fe554c72&scoped=true"
import script from "./YesButton.vue?vue&type=script&lang=js"
export * from "./YesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe554c72",
  null
  
)

export default component.exports